import React, { useEffect, useRef, useState, useCallback } from "react";
import { useReactToPrint } from "react-to-print";

import { Button, Card, Col, Container, Form, Nav, Row } from "react-bootstrap";

import StickyBox from "react-sticky-box";

import { WarningCard, LoadingSpinner } from "../../components";

import "./GNSSPerformanceReport.css";

import {
  GNSSContinuityCard,
  GNSSDegradationEventsCard,
  GNSSMajorFailureCard,
  GNSSPositioningAccuracyCard,
  GNSSRangeDomainAccuracyCard,
  GNSSServiceAvailabilityCard,
  GNSSSimultaneousMajorFailures,
  GeneralDescriptionCard,
  SBASContinuityCard,
  SBASIntegrityCard,
  SBASServiceNoticesCard,
  SBASWarningsAndAlarmsCard,
  SBASInterferenceStatisticsCard,
  SBASPositioningAccuracyCard,
  SBASServiceAvailabilityCard,
} from "components";

import { COLORS } from "utils/colors";

import { DatePickerEdit, SelectEdit } from "components";
import { useLocation } from "react-router-dom";
import { useGnssApi } from "utils/hooks";
import { useFilter } from "utils/hooks";

const Sidebar = React.memo((props) => {
  const api = useGnssApi();
  const [startDate, setStartDate] = useState(props.initialDate);
  const [dates, setDates] = useState([]);

  useEffect(() => {
    if (props.selectedStation.groupNames && props.selectedStation.identifier)
      getReportsDateByStationId();
  }, [props.selectedStation]);

  useEffect(() => {
    setStartDate(props.initialDate);
  }, [props.initialDate]);

  const getReportsDateByStationId = async () => {
    try {
      let response = await api.getReportsDatesById(
        props.selectedStation.groupNames[0],
        props.selectedStation.identifier
      );
      response=response.data;
      setDates(response);
      return response;
    } catch (e) {
      //alert(e)
      //throw e;
    }
  };

  function CustomInput({ onFocus, value, onChange }) {
    return (
      <Container className="position-relative p-0 d-flex align-items-center">
        {/* Image Element */}
        <img
          style={{
            position: "relative",
            marginLeft: "auto",

            color: "red",
          }}
          width={16}
          height={16}
          src="/icons/calendar.png"
          alt="Arrow Icon"
        />

        {/* Input Element */}
        <Form.Control
          type="text"
          className="position-absolute top-50 start-50 translate-middle"
          style={{
            width: "100%",
            color: "red",
            margin: 0,
            background: "transparent",
            border: 2,
          }}
          value={value}
          onFocus={onFocus}
          onChange={onChange}
        />
      </Container>
    );
  }

  return (
    <Nav
      activeKey={props.activeKey}
      style={{
        overflowY: "auto",
        overflowX: "clip",
        height: "calc(100vh - 56px)",
        width: props.width,
        borderLeft: "1px solid #4e4d4d",
      }}
      variant="pills"
      md={12}
      className="d-none d-md-block sidebarNav sidebar"
    >
      <div key={"nav-title"} className="pt-3 ">
        <Col md={{ span: 8, offset: 2 }}>
          <h6 className="text-center" style={{ color: "white" }}>
            {props.title}
          </h6>
        </Col>
      </div>
      <div key={"nav-date"} className="mt-3 ">
        <Col key={"report-form-col"} md={{ span: 10, offset: 1 }}>
          <SelectEdit
            label={"Change station"}
            onChange={(e) => {
              props.onStationChanged(e.target.value);
            }}
          >
            {props.stations ? (
              props.stations
                .sort((a, b) => {
                  // Move item with `property === value` to front
                  if (a.identifier === props.selectedStation.identifier) return -1;
                  if (b.identifier === props.selectedStation.identifier) return 1;
                  return 0;
                })
                .map((station, index) => {
                  return (
                    <option key={index} value={station.identifier}>
                      {station.name}
                    </option>
                  );
                })
            ) : (
              <></>
            )}
          </SelectEdit>
          <DatePickerEdit
            label={"Change report date"}
            startDate={startDate}
            disabled={props.dateDisabled}
            dates={dates}
            onChange={(date) => {
              props.onDateChanged(date);
              setStartDate(date);
            }}
          />
        </Col>
      </div>
      <hr key={"divider"} />
      <Nav.Item key={"nav-item-0"}>
        <Nav.Link
          eventKey="link-0"
          onClick={() => {
            props.onHandleBackClick(0, props.title);
          }}
        >
          <strong>General</strong>
        </Nav.Link>
      </Nav.Item>
      <Nav.Item key={"nav-item-1"}>
        <Nav.Link
          eventKey="link-1"
          onClick={() => {
            props.onHandleBackClick(1, props.title);
          }}
        >
          <strong>GNSS Signal Performance</strong>
        </Nav.Link>
      </Nav.Item>
      <Nav.Item key={"nav-item-2"}>
        <Nav.Link
          eventKey="link-2"
          onClick={() => {
            props.onHandleBackClick(2, props.title);
          }}
        >
          <span style={{ margin: 10 }}>
            <small>GNSS Positioning Accuracy</small>
          </span>
        </Nav.Link>
      </Nav.Item>
      <Nav.Item key={"nav-item-3"}>
        <Nav.Link
          eventKey="link-3"
          onClick={() => {
            props.onHandleBackClick(3, props.title);
          }}
        >
          <span style={{ margin: 10 }}>
            <small>GNSS Range Domain Accuracy</small>
          </span>
        </Nav.Link>
      </Nav.Item>
      <Nav.Item key={"nav-item-4"}>
        <Nav.Link
          eventKey="link-4"
          onClick={() => {
            props.onHandleBackClick(4, props.title);
          }}
        >
          <span style={{ margin: 10 }}>
            <small>GNSS Service Availability</small>
          </span>
        </Nav.Link>
      </Nav.Item>
      <Nav.Item key={"nav-item-5"}>
        <Nav.Link
          eventKey="link-5"
          onClick={() => {
            props.onHandleBackClick(5, props.title);
          }}
        >
          <span style={{ margin: 10 }}>
            <small>GNSS Continuity</small>
          </span>
        </Nav.Link>
      </Nav.Item>
      <Nav.Item key={"nav-item-6"}>
        <Nav.Link
          eventKey="link-6"
          onClick={() => {
            props.onHandleBackClick(6, props.title);
          }}
        >
          <span style={{ margin: 10 }}>
            <small>Probability of major service failure</small>
          </span>
        </Nav.Link>
      </Nav.Item>
      <Nav.Item key={"nav-item-7"}>
        <Nav.Link
          eventKey="link-7"
          onClick={() => {
            props.onHandleBackClick(7, props.title);
          }}
        >
          <span style={{ margin: 10 }}>
            <small>
              Probability of simultaneous major failures of two or more
              satellites
            </small>
          </span>
        </Nav.Link>
      </Nav.Item>
      <Nav.Item key={"nav-item-8"}>
        <Nav.Link
          eventKey="link-8"
          onClick={() => {
            props.onHandleBackClick(8, props.title);
          }}
        >
          <span style={{ margin: 10 }}>
            <small>GNSS degradation events</small>
          </span>
        </Nav.Link>
      </Nav.Item>

      <Nav.Item key={"nav-item-9"}>
        <Nav.Link
          eventKey="link-9"
          onClick={() => {
            props.onHandleBackClick(9, props.title);
          }}
        >
          <strong>SBAS Signal Performance</strong>
        </Nav.Link>
      </Nav.Item>
      <Nav.Item key={"nav-item-10"}>
        <Nav.Link
          eventKey="link-10"
          onClick={() => {
            props.onHandleBackClick(10, props.title);
          }}
        >
          <span style={{ margin: 10 }}>
            <small>SBAS Positioning Accuracy</small>
          </span>
        </Nav.Link>
      </Nav.Item>
      <Nav.Item key={"nav-item-11"}>
        <Nav.Link
          eventKey="link-11"
          onClick={() => {
            props.onHandleBackClick(11, props.title);
          }}
        >
          <span style={{ margin: 10 }}>
            <small>SBAS Availability</small>
          </span>
        </Nav.Link>
      </Nav.Item>
      <Nav.Item key={"nav-item-12"}>
        <Nav.Link
          eventKey="link-12"
          onClick={() => {
            props.onHandleBackClick(12, props.title);
          }}
        >
          <span style={{ margin: 10 }}>
            <small>SBAS Continuity</small>
          </span>
        </Nav.Link>
      </Nav.Item>
      <Nav.Item key={"nav-item-13"}>
        <Nav.Link
          eventKey="link-13"
          onClick={() => {
            props.onHandleBackClick(13, props.title);
          }}
        >
          <span style={{ margin: 10 }}>
            <small>SBAS Integrity</small>
          </span>
        </Nav.Link>
      </Nav.Item>
    </Nav>
  );
});

export const GNSSPerformanceReport = ({ route, navigation }) => {
  const api = useGnssApi();
  const refs = useRef([]);
  const myRef = React.createRef();
  const reportPrintRef = useRef();
  const { groupFilter } = useFilter();

  const [report, setReport] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [stopDate, setStopDate] = useState(null);
  const [warning, setWarning] = useState({
    title: "",
    message: "",
    blocking: false,
  });

  const [isDateDisabled, setDateDisabled] = useState(false);

  var currentScroll = 0;
  const [currentIndex, setCurrrentIndex] = useState(0);
  const [stationsDetails, setStationsDetails] = useState();
  const [selectedStation, setSelectedStation] = useState("");
  const location = useLocation();

  useEffect(() => {
    if (location.state?.identifier && stationsDetails) {
      setSelectedStation(
        (stationsDetails?.find(
          (station) => station.identifier === location.state?.identifier
        ))
      );
    } else {
      stationsDetails?.length > 0
        ? setSelectedStation(stationsDetails[0])
        : {};
    }
  }, [location, stationsDetails]);

  useEffect(() => {
    getAllStationsDetails();
  }, []);

  useEffect(() => {
    if (selectedStation) {
      setStartDate(null);
      setStopDate(null);
      getLastReport();
    }
  }, [selectedStation]);

  const handleBackClick = useCallback((index, title) => {
    setCurrrentIndex(index);
    refs.current[index].scrollIntoView({ behavior: "smooth" });
  });

  const setCardRef = useCallback((ref, index) => {
    refs.current[index] = ref;

    if (ref && refs.current[index] !== ref) {
      refs.current[index] = ref;
    }
  }, []);

  const onWheelScroll = useCallback(() => {
    const scrollTop = myRef.current.scrollTop;
    setCurrrentIndex((prevIndex) => {
      let newIndex = prevIndex;

      if (currentScroll < scrollTop) {
        refs.current.forEach((el, index) => {
          if (el.getBoundingClientRect().top < 250 && index > prevIndex) {
            newIndex = index;
            return;
          }
        });
      } else {
        refs.current.forEach((el, index) => {
          if (el.getBoundingClientRect().bottom > 100 && index < prevIndex) {
            newIndex = index;
            return;
          }
        });
      }

      currentScroll = scrollTop;

      return newIndex !== prevIndex ? newIndex : prevIndex;
    });
  });

  const handleDateChanged = (date) => {
    const utcDate = date.toDate();
    const offsetHours = -date.toDate().getTimezoneOffset() / 60;
    utcDate.setHours(offsetHours, 0, 0, 0);

    getReportByDate(utcDate.toISOString().split("T")[0]);
  };

  const getAllStationsDetails = async () => {
    try {
      setIsLoading(true);
      let response = await api.getAllStationsDetails();
      
      if (!response?.data || response?.data.length === 0) {
        setIsLoading(false);
        setIsSuccess(false);
        setWarning({
          title: "No stations available",
          message: `Your administrator hasn’t granted you access to the stations. Please contact your administrator to request the required permissions.  
  If you are the administrator, please ensure that your account has the necessary permissions and that at least one network and receiver are configured in the platform settings.`,
          blocking: true,
        });

        return;
      }
      
      setIsLoading(true);
      response.data = response.data.filter((station) =>
          station.groupNames.some(
            (groupName) => !groupFilter.includes(groupName)
          )
        );
      
      setStationsDetails(response?.data);

      setIsLoading(false);
      return response;
    } catch (e) {
      setIsLoading(false);
      //console.error("Failed to fetch stations", e);

      setIsSuccess(false);
      setWarning({
        title: "No stations available",
        message: `Your administrator hasn't granted you access to the receiver. If you are the administrator please check that you have networks and stations added in platform  `,

        blocking: true,
      });
    }
  };

  const getReportByDate = async (date) => {
    try {
      if (refs.current[0])
        refs.current[0].scrollIntoView({ behavior: "smooth" });

      setIsLoading(true);
      let response = await api.getReportByStationAndDate(
        selectedStation.groupNames[0],
        selectedStation.identifier,
        date
      );
      
      setIsLoading(false);

      if (response.status !== "SUCCESS") {
        setIsSuccess(false);
        setWarning({
          title: "No reports generated for the selected time interval",
          message: `The station with identifier ${selectedStation.identifier} didn't generate any performance reports for the selected date. Please choose another date.`,
          blocking: false,
        });

        return;
      }

      setReport(response?.data);
      setStartDate(response?.data.startDate);
      setStopDate(response?.data.stopDate);
      setIsSuccess(true);
      return response;
    } catch (e) {
      setIsLoading(false);
      setIsSuccess(false);
    }
  };

  const getLastReport = async () => {
    try {
      setIsLoading(true);
      const response = await api.getLastReportByStation(
        selectedStation.groupNames[0],
        selectedStation.identifier
      );
      // response = response.data;

      setIsLoading(false);
      if (response.status !== "SUCCESS") {
        setIsSuccess(false);
        setWarning({
          title: "No reports generated for this station",
          message: `The station with identifier ${selectedStation.identifier} didn't generate any performance reports. Please choose another station.`,
          blocking: false,
        });
        setDateDisabled(true);
        return;
      }
      setDateDisabled(false);
      setReport(response?.data);
      setStartDate(response?.data.startDate);
      setStopDate(response?.data.stopDate);
      setIsSuccess(true);
      return response;
    } catch (e) {
      setIsLoading(false);
      setIsSuccess(false);
      //throw e;
    }
  };

  const handlePrint = useReactToPrint({
    content: () => reportPrintRef.current,
  });

  if (isLoading) return <LoadingSpinner />;

  if (!isSuccess && !isLoading && warning.blocking)
    return <WarningCard {...warning} />;

  return (
    <>
      <div
        ref={myRef}
        onWheel={isSuccess ? onWheelScroll : () => {}}
        style={{
          background: COLORS.black,
          width: "calc(100vw - 250px)",
          display: "flex",
          alignItems: "flex-start",
          marginTop: 0,
          position: "realtive",
          height: "calc(100vh - 56px)",
          overflow: "auto",
        }}
      >
        <StickyBox>
          <Sidebar
            activeKey={"link-" + currentIndex}
            title={selectedStation.name}
            selectedStation={selectedStation}
            width={300}
            dateDisabled={isDateDisabled}
            onHandleBackClick={(index, title) =>
              isSuccess && handleBackClick(index, title)
            }
            onStationChanged={(e) =>{
              setSelectedStation(
                stationsDetails.find((station) => {
                  return station.identifier === e;
                })
              )}
            }
            initialDate={stopDate}
            onDateChanged={(date) => handleDateChanged(date)}
            stations={stationsDetails ? stationsDetails : []}
          />
        </StickyBox>

        <div
          className="reportContent"
          style={{
            position: "relative",
            padding: 0,
            width: "calc(100% - 300px)",
          }}
        >
          {!isSuccess && !isLoading && !warning.blocking && (
            <WarningCard {...warning} />
          )}
          {isSuccess && !isLoading && (
            <>
              <div className="align-items-end m-3">
                <Button
                  className="mb-1 mr-1"
                  size="md"
                  variant="primary"
                  onClick={handlePrint}
                >
                  Print as PDF
                </Button>
              </div>

              <div ref={reportPrintRef}>
                <GeneralDescriptionCard
                  ref={(ref) => {
                    setCardRef(ref, 0);
                  }}
                  data={report.data}
                  stationName={selectedStation.name}
                  stationCity={selectedStation.city}
                  stationCoords={selectedStation.positionDMS}
                  startDate={startDate}
                  stopDate={stopDate}
                />

                <Row className="m-3">
                  <Col md={{ span: 12, offset: 0 }}>
                    <Card>
                      <Card.Header
                        as="h4"
                        ref={(ref) => {
                          setCardRef(ref, 1);
                        }}
                      >
                        GNSS Signal in Space Performance
                      </Card.Header>
                      <Card.Body>
                        <Card.Title as="h6">
                          GNSS core constellations
                        </Card.Title>
                        <p className="text-justify">
                          The monitored GNSS systems and frequencies are:
                        </p>
                        <ul>
                          <li>GPS L1</li>
                          <li>GALILEO E1</li>
                          <li>GLONASS L1</li>
                        </ul>

                        <p className="text-justify">
                          GPS and GLONASS performances are compared to the ICAO
                          requirements from Doc. 9849 GNSS Manual, Table 7-1 and
                          Annex 10, Volume I. Galileo performance is compared to
                          the requirements from European GNSS (Galileo) Open
                          Service –Service Definition Document.
                        </p>

                        {report.data.gnssInfo.positioningAccuracy ? (
                          <GNSSPositioningAccuracyCard
                            ref={(ref) => {
                              setCardRef(ref, 2);
                            }}
                            data={report.data.gnssInfo.positioningAccuracy}
                          />
                        ) : (
                          <></>
                        )}
                        {report.data.gnssInfo.rangeDomainAccuracy ? (
                          <GNSSRangeDomainAccuracyCard
                            ref={(ref) => {
                              setCardRef(ref, 3);
                            }}
                            data={report.data.gnssInfo.rangeDomainAccuracy}
                          />
                        ) : (
                          <></>
                        )}
                        {report.data.gnssInfo.serviceAvailability ? (
                          <GNSSServiceAvailabilityCard
                            ref={(ref) => {
                              setCardRef(ref, 4);
                            }}
                            data={report.data.gnssInfo.serviceAvailability}
                          />
                        ) : (
                          <></>
                        )}
                        {report.data.gnssInfo.continuity ? (
                          <GNSSContinuityCard
                            ref={(ref) => {
                              setCardRef(ref, 5);
                            }}
                            data={report.data.gnssInfo.continuity}
                          />
                        ) : (
                          <></>
                        )}
                        {report.data.gnssInfo
                          .probabilityOfMajorServiceFailure ? (
                          <GNSSMajorFailureCard
                            ref={(ref) => {
                              setCardRef(ref, 6);
                            }}
                            data={
                              report.data.gnssInfo
                                .probabilityOfMajorServiceFailure
                            }
                          />
                        ) : (
                          <></>
                        )}
                        {report.data.gnssInfo
                          .probabilityOfSimultaneousMajorFailures ? (
                          <GNSSSimultaneousMajorFailures
                            ref={(ref) => {
                              setCardRef(ref, 7);
                            }}
                            data={
                              report.data.gnssInfo
                                .probabilityOfSimultaneousMajorFailures
                            }
                          />
                        ) : (
                          <></>
                        )}
                        {/* <GNSSDegradationEventsCard ref={(ref) => { refs[8] = ref }} filePath={reportPath} /> */}

                        <GNSSDegradationEventsCard
                          ref={(ref) => {
                            setCardRef(ref, 8);
                          }}
                          data={report.data.gnssInfo.gnssDegradationEvt}
                        />
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>

                <Row className="m-3">
                  <Col md={{ span: 12, offset: 0 }}>
                    <Card>
                      <Card.Header
                        as="h4"
                        ref={(ref) => {
                          setCardRef(ref, 9);
                        }}
                      >
                        SBAS
                      </Card.Header>
                      <Card.Body>
                        <p className="text-justify">
                          The monitored SBAS is EGNOS.<br></br>
                          EGNOS performance is compared to the ICAO requirements
                          from Annex 10, Volume I, Table 3.7.2.4-1. The
                          description of EGNOS Safety of Life service
                          performance is available in the EGNOS Safety of Life
                          Service Definition Document.
                        </p>
                        {report.data.sbasInfo.positioningAccuracy ? (
                          <SBASPositioningAccuracyCard
                            ref={(ref) => {
                              setCardRef(ref, 10);
                            }}
                            data={report.data.sbasInfo.positioningAccuracy}
                          />
                        ) : (
                          <></>
                        )}
                        {report.data.sbasInfo.serviceAvailability ? (
                          <SBASServiceAvailabilityCard
                            ref={(ref) => {
                              setCardRef(ref, 11);
                            }}
                            data={report.data.sbasInfo.serviceAvailability}
                          />
                        ) : (
                          <></>
                        )}
                        {report.data.sbasInfo.serviceContinuity ? (
                          <SBASContinuityCard
                            ref={(ref) => {
                              setCardRef(ref, 12);
                            }}
                            data={report.data.sbasInfo.serviceContinuity}
                          />
                        ) : (
                          <></>
                        )}

                        <SBASIntegrityCard
                          ref={(ref) => {
                            setCardRef(ref, 13);
                          }}
                          plots={
                            report?.data?.stanfordPlots
                          }
                        />
                        {/* <SBASServiceNoticesCard ref={(ref) => { refs[14] = ref }} /> */}
                        {/* <SBASWarningsAndAlarmsCard ref={(ref) => { refs[15] = ref }} /> */}
                        {/* <SBASInterferenceStatisticsCard ref={(ref) => { refs[16] = ref }} startDate={report.startDate} stopDate={report.stopDate} /> */}
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </div>
            </>
          )}
        </div>
      </div>

      {/* </div> */}
    </>
  );
};
